<template>
  <div>
    <!-- 院校用户标题 -->
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <!-- table 表格 -->
    <ots-table-group-new
      :selectList="selectList"
      :requestForm="selectForm"
      :tableHeader="tableHeader"
      :tableOption="tableOption"
      :tableData="tableData"
      :pagination="pagination"
      @search="search"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>
    <!-- 新增/编辑院校用户 -->
    <ots-custom-dialog
      :dialog.sync="downDialog"
      :title="isAddDesc"
      width="640px"
    >
      <template v-slot:content>
        <div class="exportDialog">
          <el-form :model="addUserForm" ref="addUserForm" :rules="addUsers">
            <!-- 用户名 -->
            <el-form-item label="用户名" prop="userName">
              <!-- 
                onkeyup="this.value=this.value.replace(/[^\w_]/g,'');"
                onkeyup="this.value=this.value.replace(/[^\w_]/g,'');"
               -->
              <el-input
                v-model.trim="addUserForm.userName"
                placeholder="请输入"
                :disabled="!isdisabled"
                auto-complete="new-text"
              ></el-input>
            </el-form-item>
            <!-- 密码 -->
            <el-form-item label="密码" prop="password" v-if="isdisabled">
              <el-input
                v-model="addUserForm.password"
                placeholder="请输入"
                type="password"
                auto-complete="new-password"
              ></el-input>
              <ots-password-tooltip></ots-password-tooltip>

            </el-form-item>
            <!-- 院校列表 -->
            <el-form-item label="院校" prop="schoolId">
              <el-select
                v-model="addUserForm.schoolId"
                placeholder="请选择"
                :disabled="!isdisabled"
              >
                <el-option
                  v-for="item in schoolIds"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 所属角色 -->
            <el-form-item
              label="所属角色"
              style="width: 100%;"
              prop="roleIds"
            >
            <div class="checkUser">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                style="width: 100%"
                >全选</el-checkbox
              >
              <div style="margin: 15px 0"></div>
              <el-checkbox-group
                v-model="addUserForm.roleIds"
              >
                <el-checkbox
                  v-for="item in roleUsers"
                  :label="item.id"
                  :key="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form-item>
            <!-- 姓名 -->
            <el-form-item label="姓名" prop="realName">
              <el-input
                v-model="addUserForm.realName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <!-- 手机号 -->
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="addUserForm.phone"
                placeholder="请输入"
              ></el-input>
            </el-form-item>

            <el-form-item label="状态" prop="state">
              <el-radio-group v-model="addUserForm.state">
                <el-radio-button label="1">启用</el-radio-button>
                <el-radio-button label="0">停用</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="downDialog = false">取消</el-button>
        <el-button
          round
          type="primary"
          @click="addSchoolUserSet('addUserForm')"
          v-if="isdisabled"
          >确定</el-button
        >
        <el-button
          round
          type="primary"
          @click="editSchoolUserSet('addUserForm')"
          v-else
          >确定</el-button
        >
      </template>
    </ots-custom-dialog>

    <!-- 重置密码 -->
    <ots-custom-dialog
      :dialog.sync="passDownDialog"
      title="重置密码"
      width="480px"
    >
      <template v-slot:content>
        <div class="repass">
          <div class="name">
            <span class="name-username">用户名</span>
            <span>{{ rePassUserName }}</span>
          </div>
          <div class="name">
            <span class="name-realname">姓名</span>
            <span>{{ rePassRealName }}</span>
          </div>
          <el-form :model="resetPass" ref="resetPass" :rules="passRule">
            <!-- 密码 -->
            <el-form-item label="新密码" prop="password">
              <el-input
                v-model="resetPass.password"
                placeholder="请输入新密码"
                type="password"
              ></el-input>
              <ots-password-tooltip></ots-password-tooltip>
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmPassword">
              <el-input
                v-model="resetPass.confirmPassword"
                placeholder="请输入新密码"
                type="password"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="passDownDialog = false">取消</el-button>
        <el-button round type="primary" @click="editPassWord('resetPass')"
          >确定</el-button
        >
      </template>
    </ots-custom-dialog>
  </div>
</template>

<script>
import {
  getSystemUserListInfo,
  getTypeRoleListInfo,
  addSystemUserSet,
  getEditUserDataList,
  editUserSet,
  deleteUserSet,
} from "@/http/modules/user.js";
import { checkChinese, passWordStrength } from "@/common/verify.js";

export default {
  data() {
    return {
      /* ***** 重置密码 ***** */
      passDownDialog: false,
      rePassUserName: "",
      rePassRealName: "",

      resetPass: {
        password: "",
        confirmPassword: "",
      },
      passRule: {
        password: [
          { required: true, message: "请输入设置密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ],
      },
      /* ***** 添加院校用户 ***** */
      isAddDesc: "",
      isdisabled: true,
      downDialog: false,
      addUserForm: {
        // 用户名
        realName: "",
        userName: "",
        searchKey: "",
        // 密码
        password: "",
        // 院校列表id
        schoolId: "",
        // 状态
        state: "1",
        // 手机
        phone: "",
        // 所属角色列表
        roleIds: [],
      },
      schoolIds: [],
      addUsers: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { max: 50, message: "最多可输入50个字!", trigger: "blur" },
          { validator: checkChinese, trigger: "blur" },
        ],
        phone: [{ validator: this.isCheckPhone, trigger: "blur" }],
        password: [
          { required: true, message: "请输入设置密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        schoolId: [{ required: true, message: "请选择院校", trigger: "blur" }],
        state: [{ required: true, message: "请选择状态", trigger: "blur" }],
        realName: [
          { required: true, message: "请填写您的姓名", trigger: "blur" },
        ],
        roleIds: [
          { required: true, message: "请勾选所属角色", trigger: "blur" },
        ],
      },
      checkAll: false,

      roleUsers: [],
      isIndeterminate: false,

      /* ***** 角色管理标题 ***** */
      mainTopBtnList: [
        {
          title: "新增",
          fn: this.addSchoolUser,
        },
      ],
      /* ***** 表单值 ***** */
      selectForm: {
        roleType: "2",
        schoolId: "",
        state: "",
        searchKey: "",
        size: 10,
        page: 1,
      },
      /* ***** 表单配置 ***** */
      selectList: [
        {
          title: "院校",
          type: "select",
          isSearch: true,
          requestKey: "schoolId",
          label: "name",
          value: "id",
          data: [
            {
              id: "",
              name: "全部",
            },
          ],
        },
        {
          title: "用户状态",
          type: "select",
          requestKey: "state",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: "",
            },
            {
              key: "禁用",
              value: "0",
            },
            {
              key: "启用",
              value: "1",
            },
          ],
        },

        {
          title: "关键词",
          type: "input",
          requestKey: "searchKey",
          placeholder: "用户名/姓名",
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入",
        },
      ],
      /* ***** 表格 ***** */
      tableData: [],
      tableOption: {},
      tableHeader: [
        {
          title: "院校",
          prop: "schoolName",
          fixed: "left",
        },
        {
          title: "用户名",
          prop: "userName",
          fixed: "left",
        },
        {
          title: "姓名",
          prop: "realName",
          fixed: "left",
        },
        {
          title: "手机号",
          prop: "phone",
          fixed: "left",
        },
        {
          title: "所属角色",
          prop: "roleName",
          fixed: "left",
        },
        {
          title: "用户状态",
          prop: "state",
          type: "switch",
          switchChange: this.changeClassState,
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "编辑",
              click: this.editSchoolUser,
            },
            {
              title: "重置密码",
              click: this.resetPassword,
            },
            {
              title: "删除",
              click: this.deleteSchoolUser,
            },
          ],
        },
      ],
      /* ***** 分页 ***** */
      pagination: {
        total: 0,
        size: 10,
      },
      roleType: "",
      schoolIdYx: "",
      isdisableds:false
    };
  },
  created() {
    this.initDate();
  },
  mounted() {
    this.getSelectList();

    this.getResult();
  },
  methods: {
    /********************************
     * @this 表单搜索功能
     ********************************/
    search() {
      this.selectForm.page = 1;
      this.getResult();
    },

    /********************************
     * @this 获取表格数据***table***
     ********************************/
    getResult() {
      this.mixin_getCommonInfo().then((res) => {
        this.roleType = res.roleType;
        if (res.roleType === 2) {
          this.selectForm.schoolId = res.schoolId;
          this.addUserForm.schoolId = res.schoolId;
        }
        getSystemUserListInfo(this.selectForm).then((res) => {
          res.data.records.forEach((e) => {
            // 1. 接口返回 String , 转 Number
            e.state = Number(e.state);
          });
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
        });
      });
    },
    initDate() {
      this.mixin_getCommonInfo().then((res) => {
        this.roleType = res.roleType;
        if (res.roleType === 2) {
          this.schoolIdYx = res.schoolId;
        }
      });
    },
    /********************************
     * @this 新增院校用户(右上角按钮)
     ********************************/
    addSchoolUser() {
      // 1. 开启弹窗
      if(this.roleType ===2){
        this.isdisableds = false
      }else{
        this.isdisableds = true
      }
      this.downDialog = true;
      // 2. 开启表单状态
      this.isdisabled = true;
      this.isAddDesc = "新增院校用户";
      // 3. 重置表单信息
      this.addUserForm.userName = "";
      this.addUserForm.phone = "";
      this.addUserForm.realName = "";
      this.addUserForm.state = "1";
     
      (this.addUserForm.password = ""), (this.addUserForm.roleIds = "");
      // 4. 所属角色列表
      this.roleUsers = [];
      // 5. 已选中的所属角色 id 列表
      this.addUserForm.roleIds = [];
      this.isIndeterminate = false;
      // 6.获取所属角色列表
      getTypeRoleListInfo({ typeId: 2 }).then((res) => {
        if (res.code == 1) {
          this.roleUsers = res.data;
        }
      });
    },

    /****************************
     * @this 判断用户名是否重复(新增)
     ***************************/
    // isRepeatUser(rule, value, callback){
    //   this.tableData.forEach(e=>{
    //     if(e.userName == value){
    //       callback(new Error('用户名称重复！'));
    //     }
    //   })
    //   callback();
    // },

    /********************************
     * @this 权限类型对应的所属角色列表(全选事件)
     ********************************/
    handleCheckAllChange(val) {
      this.addUserForm.roleIds = [];
        if(val){
          this.roleUsers.forEach(e=>{
            this.addUserForm.roleIds.push(e.id);
          })
        } else {
          this.addUserForm.roleIds = [];
        }
        this.isIndeterminate = false;
    },

    /********************************
     * @this 权限类型对应的角色列表(选项变化事件)
     ********************************/
    handleCheckedUsersChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.roleUsers.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.roleUsers.length;
    },

    /********************************
     * @this 手机号码验证.(可以为空)
     ********************************/
    isCheckPhone(rule, value, callback) {
      let phoneReg = /^1[3456789]\d{9}$/;
      if (value == "" || phoneReg.test(value)) {
        callback();
      } else {
        callback(new Error("手机号格式错误"));
      }
    },

    /****************************
     * @this 新增院校用户表单提交
     ***************************/
    addSchoolUserSet(formName) {
      // 1. 所属角色列表
     
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUserForm.roleIds = this.addUserForm.roleIds.join(',')
          addSystemUserSet(this.addUserForm)
            .then((res) => {
              if (res.code == 1) {
                this.$message.success("添加成功");
                this.getResult();
                this.downDialog = false;
              }
            })
            .catch((error) => {});
        } else {
          console.log("Error Submit");
          return false;
        }
      });
    },

    /********************************
     * @this 编辑院校用户(按钮)
     ********************************/
    editSchoolUser(row) {
      // 1. 修改弹窗 标题
      this.isAddDesc = "编辑院校用户";
      // 2. 开启弹窗
      this.downDialog = true;
      // 3.禁用 input 标单 , 隐藏密码输入框
      this.isdisabled = false;
      // 4. 获取所有 所属角色列表
      getTypeRoleListInfo({ typeId: 2 }).then((res) => {
        if (res.code == 1) {
          this.roleUsers = res.data;
        }
      });
      getEditUserDataList({ userId: row.id, typeId: 2 }).then((res) => {
        this.addUserForm.roleIds = [];
        // 5. 设置编辑表单默认数据
        if (res.code == 1) {
          // 6. 获取 选中的所属角色列表
          if (res.data.roleList.length) {
            res.data.roleList.forEach((e) => {
              if (e.isHave == 1) {
                this.addUserForm.roleIds.push(e.id);
                
              }
            });
          }
          // 7. 全选按钮样式
          this.isIndeterminate = this.addUserForm.roleIds.length ? true : false;
          this.addUserForm.userName = res.data.userName;
          this.addUserForm.phone = res.data.phone || "";
          this.addUserForm.realName = res.data.realName;
          this.addUserForm.state = res.data.state;
          this.roleUsers = res.data.roleList;
          this.schoolIds.forEach((e) => {
            if (e.name == res.data.schoolName) {
              this.addUserForm.schoolId = e.id;
            }
          });
        }
      });
    },

    /********************************
     * @this 编辑院校用户表单提交
     ********************************/
    editSchoolUserSet(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 1. 院校用户--所属角色

          // 2. 配置修改 院校用户信息 参数
          let param = {
            phone: this.addUserForm.phone,
            realName: this.addUserForm.realName,
            roleIds :this.addUserForm.roleIds.join(','),
            state: this.addUserForm.state,
            userName: this.addUserForm.userName,
          };
          // 3. 修改院校用户信息
          editUserSet(param).then((res) => {
            if (res.code == 1) {
              this.downDialog = false;
              this.getResult();
              this.$message.success("操作成功！");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /********************************
     * @this 用户状态改变
     ********************************/
    async changeClassState(row) {
      // 1. 设置所属角色列表为空
      this.addUserForm.roleIds= [];
      // 2. 获取所属角色选中 id 列表
      await getEditUserDataList({ userId: row.id,typeId: 2 }).then((res) => {
        if (res.data.roleList.length) {
          res.data.roleList.forEach((e) => {
            if (e.isHave == 1) {
              this.addUserForm.roleIds.push(e.id);
            }
          });
        }
      });
      // 3. 配置修改 院校用户 参数
      let param = {
        state: row.state,
        userName: row.userName,
        roleIds: this.addUserForm.roleIds.join(),
        realName: row.realName,
        phone: row.phone,
      };
      // 4. 修改院校用户启用状态
      editUserSet(param).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功！");
        }
      });
    },

    /********************************
     * @this 重置密码
     ********************************/
    resetPassword(row) {
      this.passDownDialog = true;
      this.rePassUserName = row.userName;
      this.rePassRealName = row.realName;
      this.resetPass.password = "";
      this.resetPass.confirmPassword = "";
      this.resetPass.userId = row.id;
      this.resetPass.tenant = localStorage.getItem("tenant");
    },

    /********************************
     * @this 重置密码表单失焦事件
     ********************************/
    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.resetPass.password !== this.resetPass.confirmPassword) {
          callback(new Error("设置密码和确认密码必须相同"));
        } else {
          callback();
        }
      }
      callback();
    },

    /********************************
     * @this 修改密码表单提交按钮
     ********************************/
    editPassWord(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.login.editPsd(this.resetPass).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功！");
              this.passDownDialog = false;
            }
          });
        } else {
          console.log("Error Submit");
          return false;
        }
      });
    },

    /********************************
     * @this 删除列表数据
     ********************************/
    deleteSchoolUser(row) {
      // 1. 删除用户二次确认
      this.$confirm("是否确认删除用户？", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteUserSet({ userId: row.id }).then((res) => {
            if (res.code == 1) {
              this.$message.success("删除成功！");
              this.getResult();
            }
          });
        })
        .catch(() => {});
    },

    /********************************
     * @this 获取所有院校列表
     ********************************/
    getSelectList() {
      this.mixin_getSelectSchool().then((data) => {
        let newSchoolList = [
          {
            id: "",
            name: "全部",
          },
          ...data,
        ];
        this.$set(this.selectList[0], "data", newSchoolList);
        this.schoolIds = data;
      });
    },

    /****************************
     * @this 分页相关
     ***************************/
    changeSize(num) {
      this.pagination.size = num;
      this.selectForm.size = num;
      this.getResult();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getResult();
    },
  },
};
</script>

<style lang="less" scoped>
.exportDialog {
  .el-form {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .el-form-item {
      width: 260px;
    }
    /deep/ .el-input__inner {
      width: 260px;
    }
    .checkUser {
      width: 100%;
      background: #f8f9fc;
      border-radius: 4px;
      padding: 19px 0 0 16px;
      margin-bottom: 22px;
      /deep/ .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        .el-checkbox {
          margin-right: 0;
          margin-bottom: 12px;
          width: 50%;
        }
      }
    }
  }
}
.repass {
  .name {
    width: 50%;
    display: inline-block;
    padding-left: 4px;
    box-sizing: border-box;
    margin-bottom: 32px;
    .name-username,
    .name-realname {
      color: #737780;
      font-size: 14px;
      font-weight: 400;
      display: inline-block;
      margin-right: 16px;
    }
    .name-username + span,
    .name-realname + span {
      color: #45494d;
    }
  }
  .el-form {
    width: 100%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .el-form-item {
      width: 408px;
      /deep/ .el-form-item__label {
        color: #737780;
      }
    }
    /deep/ .el-input__inner {
      width: 408px;
    }
    .checkUser {
      width: 100%;
      background: #f8f9fc;
      border-radius: 4px;
      padding: 19px 0 0 16px;
      margin-bottom: 22px;
      /deep/ .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
        .el-checkbox {
          margin-right: 0;
          margin-bottom: 12px;
          width: 50%;
        }
      }
    }
  }
}
</style>